import styled, { css } from 'styled-components';
import { up } from 'styled-breakpoints';

export const Container = styled.div`
  width: 100%;
  margin-bottom: 24px;
  border-radius: 8px;

  background-color: ${({ theme }) => theme.system.white};
`;

export const Inner = styled.div`
  padding: 16px 16px 24px;

  ${up('md')} {
    padding: 24px 24px 32px;
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 24px;

  ${up('md')} {
    grid-template-columns: 200px 1fr;
  }

  ${up('lg')} {
    grid-template-columns: 320px 1fr;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
  position: relative;
`;

export const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
`;

const tabActiveMixin = css<{ isActive?: boolean }>`
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  text-decoration: ${({ isActive }) => (isActive ? 'underline' : 'none')};
  color: ${({ theme, isActive }) => (isActive ? theme.system.black : theme.system.darkGreyActive)};
`;

export const TabButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  ${up('md')} {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const TabButton = styled.button<{ isActive?: boolean }>`
  background: none;
  border: none;
  display: block;
  font-size: 1.8rem;
  line-height: 1.25;
  margin: 8px 0;

  ${tabActiveMixin}

  &:hover {
    cursor: pointer;
  }
`;

export const Button = styled.button`
  width: 100%;
  display: block;
  padding: 11px 19px;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.25;
  border-radius: 9px;
  border-width: 1px;
  border-style: solid;
  text-align: center;

  border-color: ${({ theme }) => theme.brand.orange};
  color: ${({ theme }) => theme.system.white};
  background-color: ${({ theme }) => theme.brand.orange};

  &:not([disabled]):hover {
    cursor: pointer;
  }

  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;
    border-color: ${({ theme }) => theme.system.darkGreyActive};
    background-color: ${({ theme }) => theme.system.darkGreyActive};
  }

  ${up('md')} {
    width: auto;
  }
`;
